export default __webpack_public_path__ + "static/media/scratch2.631cc6da.mp3";